<template>
  <div class="flex flex-col gap-y-6">
    <div v-if="eventName && dateTime.length > 1" :class="headingClasses" class="font-bold">
      {{ eventName }}
    </div>
    <div
      v-for="(item, index) in dateTime"
      :key="item.id || index"
      class="flex flex-col gap-y-4"
      v-bind="getEditableAttributes(item)"
    >
      <div class="flex flex-row items-stretch">
        <div class="flex flex-col text-center rounded-t-md w-[72px] shrink-0">
          <div
            class="rounded-t-md text-[0.75rem] leading-[1rem] py-1 font-medium"
            :class="isLightMode ? 'bg-[#FEC629]' : 'bg-[#78634F] text-[#FFFFFF]'"
          >
            {{
              isSameCalendarDate(item.fromDate, item.toDate)
                ? getDay(item.fromDate)
                : `${getDay(item.fromDate)} - ${getDay(item.toDate)}`
            }}
          </div>
          <div
            class="rounded-b-md font-bold flex justify-center items-center uppercase"
            :class="[
              isCrossMonthRange(item.fromDate, item.toDate)
                ? 'text-[0.875rem] leading-[1.125rem] pt-1 pb-1 px-1 text-center whitespace-normal break-words'
                : 'text-[1rem] leading-[1.5rem] pt-1 whitespace-pre',
              isLightMode ? 'bg-[#ECEBEB]' : 'bg-[#3C3A36] text-[#FFFFFF]',
            ]"
          >
            {{
              isCrossMonthRange(item.fromDate, item.toDate)
                ? displayDateLine(item.fromDate, item.toDate)
                : displayDate(item.fromDate, item.toDate)
            }}
          </div>
          <div
            v-if="!isCrossMonthRange(item.fromDate, item.toDate)"
            class="rounded-b-md text-[0.875rem] leading-[1.25rem] mt-[-4px] pb-1 font-bold flex justify-center items-center whitespace-pre uppercase"
            :class="isLightMode ? 'bg-[#ECEBEB]' : 'bg-[#3C3A36] text-[#FFFFFF]'"
          >
            {{ displayMonth(item.fromDate, item.toDate) }}
          </div>
        </div>
        <div class="flex flex-col pl-5 gap-y-1 min-w-0">
          <div v-if="eventName && dateTime.length === 1" :class="headingClasses" class="font-bold">
            {{ eventName }}
          </div>
          <div
            v-for="(range, rangeIndex) in item.timeRange"
            :key="rangeIndex"
            class="text-[1rem] leading-[1.5rem] font-bold uppercase whitespace-nowrap"
            v-html="formatDayTime(range.dayTime)"
          ></div>
          <div
            v-if="renderNote(item.note)"
            class="text-body-md"
            v-html="renderNote(item.note)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getStoryblokEditableAttributes } from '@/utils/storyblok-editable';
import { getHeadingClasses } from '@/utils/eventPageHeading';
import { convertStoryblokRichTextToHtml } from '@/utils/storyblokRichText';
import {
  getDay,
  isSameCalendarDate,
  displayDate,
  displayMonth,
  displayDateLine,
  isCrossMonthRange,
  formatDayTime,
} from '@/utils/eventPageDateUtils';

export default {
  name: 'EventDateTimeBlock',
  props: {
    eventName: {
      type: String,
      default: '',
    },
    headingSize: {
      type: String,
      default: 'H2',
    },
    dateTime: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState('eventPage', ['isLightMode']),
    headingClasses() {
      return getHeadingClasses(this.headingSize);
    },
  },
  methods: {
    getDay,
    isSameCalendarDate,
    displayDate,
    displayMonth,
    displayDateLine,
    isCrossMonthRange,
    formatDayTime,
    renderNote(note) {
      return convertStoryblokRichTextToHtml(note);
    },
    getEditableAttributes(block) {
      return getStoryblokEditableAttributes(block);
    },
  },
};
</script>
